/**
 * CVE-Prüfung über OSV API (https://api.osv.dev)
 * Prüft npm-Pakete auf bekannte Sicherheitslücken.
 */

const OSV_API = 'https://api.osv.dev/v1/query';

// Mapping: Anzeigename -> { npmName, version }
const PACKAGE_MAP = {
  React: { npm: 'react', getVersion: (v) => v.React },
  i18next: { npm: 'i18next', getVersion: (v) => v.i18next },
  'react-router-dom': { npm: 'react-router-dom', getVersion: (v) => v['react-router-dom'] },
  workbox: { npm: 'workbox-window', getVersion: (v) => v.workbox }
};

/**
 * Fragt OSV API nach CVEs für ein npm-Paket ab.
 * @param {string} name - npm-Paketname
 * @param {string} version - Version (z.B. "18.2.0")
 * @returns {Promise<{ vulns: Array }>}
 */
export async function fetchCvesForPackage(name, version) {
  if (!name || !version || version === '?') {
    return { vulns: [] };
  }
  try {
    const res = await fetch(OSV_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        package: { name, ecosystem: 'npm' },
        version
      })
    });
    if (!res.ok) return { vulns: [] };
    const data = await res.json();
    return { vulns: data.vulns || [] };
  } catch {
    return { vulns: [] };
  }
}

/**
 * Prüft alle Tech-Stack-Module auf CVEs.
 * @param {Object} versions - Ergebnis von getTechVersions()
 * @returns {Promise<Object>} { [displayName]: { vulns: Array } }
 */
export async function checkCvesForTechStack(versions) {
  const results = {};
  const entries = Object.entries(PACKAGE_MAP);
  for (const [displayName, { npm, getVersion }] of entries) {
    const version = getVersion(versions);
    const { vulns } = await fetchCvesForPackage(npm, version);
    results[displayName] = { vulns };
  }
  return results;
}
